export enum ConsultationType {
  Online = 201,
  Offline = 205
}

export enum PaymentModeEnum {
  Online = 111,
  Cash = 110
}

export enum QuestionType {
  Single_Choice = 1,
  Multi_Choice = 2,
  Text = 3,
  Yes_No = 4,
  File_Upload = 5,
  Progress_Bar = 6,
  Date = 7,
  Number = 8,
  Dietry_Recall = 9
}

export enum QuestionTemplate {
  Document_Upload = 1,
  Grid = 2,
  List_View = 3,
  Text_Input = 4,
  Chip_Choice = 5,
  Progress_Input = 6,
  Sleep_Input = 7,
  Yes_No = 8,
  DietryRecall = 9,
  FullBodyImage = 10,
  BmiCalculation = 11,
  HealthReport = 12
}


